import { DateTime } from "luxon";

export function isExpiredJWT(exp) {
  return Date.now() - exp * 1000 >= 0;
}

export function formatName(name) {
  const [firstName, lastName] = name.split(".");
  return (
    firstName[0].toUpperCase() +
    firstName.substring(1) +
    " " +
    lastName[0].toUpperCase() +
    lastName.substring(1)
  );
}

export function revertName(formattedName) {
  return formattedName.split(" ").join(".").toLowerCase();
}

export function formatDate(date) {
  return DateTime.fromISO(date)
    .setZone("Europe/Bucharest")
    .setLocale("ro")
    .toLocaleString(DateTime.DATETIME_SHORT);
}

export function formatDestinatar(destinatar) {
  const str = destinatar.replace("LIDL DISCOUNT FILIALA ", "").split(", ");
  return str;
}

export const TRUCKS_L = [
  "B 101 TRL",
  "B 111 TRL",
  "B 220 TRL",
  "B 222 TRL",
  "B 310 TRL",
  "B 333 TRL",
  "B 350 TRL",
  "B 410 TRL",
  "B 444 TRL",
  "B 450 TRL",
  "B 550 TRL",
  "B 555 TRL",
  "B 650 TRL",
  "B 777 TRL",
  "B 996 TRL",
  "B 997 TRL",
  "B 998 TRL",
  "B 999 TRL",
  "B 126 MHS",
];

export const TRAILERS_L = [
  "B 130 TRL",
  "B 140 TRL",
  "B 230 TRL",
  "B 240 TRL",
  "B 260 TRL",
  "B 270 TRL",
  "B 280 TRL",
  "B 330 TRL",
  "B 340 TRL",
  "B 430 TRL",
  "B 440 TRL",
  "B 530 TRL",
  "B 540 TRL",
  "B 630 TRL",
  "B 640 TRL",
  "B 920 TRL",
  "B 930 TRL",
  "B 940 TRL",
];

export const TRUCKS_B = ["B 150 TRL", "B 850 TRL"];

export const TRAILERS_B = ["B 160 TRL", "B 120 TRL"];

export const INCARCARE_B = [
  "AGREWEST",
  "SALCIOARA",
  "ROM AGREGATE-PALANCA",
  "BAUMIT",
  "FLORESTI",
  "TRIER",
  "BALASTIERA NEDELEA-POTLOGI",
];

export const LIVRARE_B = ["BAUMIT-BOLINTIN"];

export const CMR_AMBALAJE_LIST = [
  "MARFA PALETIZATA - PRODUSE ALIMENTARE",
  "RETUR AMBALAJE - SGR",
];

export const CMR_DESCARCARI_LIST = [
  "5 - Chiajna/Ilfov",
  "8 - Aricesti/Prahova",
  "16 - Bolintin Deal/A1 KM 23, CT PARK",
  "88 - Costinesti/Emil Costinescu",
  "113 - Bucuresti/Turnu Magurele 16-24",
  "136 - Bucuresti/Ziduri intre Vii",
  "137 - Mangalia/Constantei",
  "158 - Bucuresti/Rebreanu",
  "161 - Bucuresti/Morarilor",
  "164 - Medgidia/Albinelor 1",
  "165 - Giurgiu/MihaiViteazu",
  "172 - Constanta 2/Baba Novac",
  "175 - Constanta1/Soveja",
  "180 - Bucuresti/Pantelinom",
  "182 - Constanta3/ICBratianu",
  "200 - Popesti-Leordeni/Oltenitei",
  "204 - Bucuresti/Theodor Pallady",
  "205 - Bucuresti/Rm. Valcea",
  "207 - Eforie Nord/Traian 1B",
  "215 - Bucuresti/Savinesti",
  "223 - Constanta/Soveja",
  "234 - Calarasi/Eroilor",
  "236 - Bucuresti/Berceni",
  "252 - Pantelimon II",
  "255 - Bucuresti/Drumul Binelui",
  "256 - Tuzla, Aviatorilor, 1A",
  "260 - Constanta Industriei Mici",
  "279 - Constanta/Mangaliei",
  "282 - Oltenita/Blvd 1 Decembrie",
  "287 - 1 Decembrie",
  "290 - Bucuresti/Energeticienilor",
  "308 - Fetesti",
  "325 - Bratarii",
  "326 - Pallady II",
  "335 - Bucuresti/Lacul Tei",
  "363 - Navodari II",
  "812 - Bucuresti/Turnu Magurele",
  "822 - Navodari/Constantei",
  "912 - Bucuresti/Gazarului",
  "913 - Bucuresti/Tarcaului",
  "247 - Bucuresti/Salaj",
  "251 - Bucuresti/Gherghitei",
  "111 - Urziceni/Calea Bucuresti",
  "190 - Voluntari/Iancu Nicolae",
  "197 - Voluntari/Voluntari",
  "219 - Cernica/Sos. Cernica",
  "222 - Voluntari/Bucuresti Nord 14",
  "233 - Bucuresti/Fundeni",
  "265 - Tulcea/Victoriei",
  "267 - Tunari/Calea Bucuresti",
  "320 - Voluntari/Eroilor",
  "331 - Voluntari/Emil Racovita",
  "872 - Slobozia/Garii",
  "877 - Tulcea/Babadag",
  "902 - Slobozia/DN 559",
  "230 - Bucuresti/Ferentari",
  "294 - Bucuresti",
  "461 - Stefanestii de Jos",
  "470 - Giurgiu 2",
  "463 - Branesti",
  "511 - Bucuresti/Barbu Vacarescu",
  "440 - Bucuresti/Pucheni",
  "416 - Bucuresti/Toporasi",
  "538 - Constanta/Aurel Vlaicu",
  "512 - Bucuresti/Berceni",
  "467 - Harsova",
  "450 - Atomestilor/Magurele",
  "238 - Teiusi/Bucuresti",
  "318 - Soseaua Alexandriei/Bucuresti",
  "167 - Doina/Bucuresti",
  "369 - Bucuresti/Ilioara 54",
  "604 - Tandarei/Pescarusului",
];

// export const API_URL = "https://safirtrans-transport-api.onrender.com";
export const API_URL =
  "https://safirtrans-transport-api-61fbb6304b19.herokuapp.com";
// export const API_URL = "http://192.168.68.104:8080";

export function rutaFilter({ options, search }) {
  return options.filter((option) => {
    return option.value.startsWith(search);
  });
}

export function downloadCSV(data) {
  if (!data.length) {
    return "";
  }

  const excludeKeys = ["_id"];

  data.forEach((obj) => (obj.date = formatDate(obj.date)));

  const translateMap = {
    date: "Data",
    truck: "Camion",
    trailer: "Remorca",
    loc_incarcare: "Loc incarcare",
    loc_livrare: "Loc livrare",
    aviz_interbulk: "Aviz Interbulk",
    aviz_safirtrans: "Aviz Safirtrans",
    cantitate: "Cantitate",
    sort: "Sort",
  };

  // Extract the headers (keys of the first object)
  const headers = Object.keys(data[0]).filter(
    (key) => !excludeKeys.includes(key),
  );

  const translatedHeaders = headers.map((header) => translateMap[header]);

  // Map the headers and data rows to CSV format
  const rows = data.map((obj) =>
    headers
      .map(
        (header) =>
          // Escape quotes and commas in values
          `"${String(obj[header] || "").replace(/"/g, '""')}"`,
      )
      .join(","),
  );

  // Combine headers and rows
  return [translatedHeaders.join(","), ...rows].join("\n");
}

export function downloadBlob(content, filename, contentType) {
  // Create a blob
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", filename);
  pom.click();
}
